import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[sukaStackItem]'
})
export class StackItem {
  @HostBinding('class.stack__item') baseClass = true;

  /**
   * Set to `true` to make the `StackItem` fill the remaining horizontal space on the stack.
   */
  @HostBinding('class.stack__item--fill') @Input() fill = false;
}
